import { useForm } from "react-hook-form";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { Suspense, useMemo, useState } from "react";
import { AdministrarPatEdit } from "../models/administrarPat";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { FilterList } from "@mui/icons-material";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { Grid2 } from "@mui/material";
import { useColumns } from "../utils/columns";
import ModalPat from "../components/modalPat";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";

interface FiltrosPat {
    rut: string;
    llavePat: string;
}

function AdministradorPat() {
    const [modalDetalle, setModalDetalle] = useState<boolean>(false);
    const [patEditar, setPatEditar] = useState<AdministrarPatEdit>();
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const urlTabla = `siscred-api-recaudacion/v1/pat/listar`;

    const controlTabla = useDataFetch(
        urlTabla,
        new URLSearchParams('filters.status='),
        true,
    );

    const {
        formState: { errors },
        control,
        handleSubmit,
    } = useForm<FiltrosPat>({
        mode: 'onBlur'
    });   

    const { COLUMNS } = useColumns({ controlTabla, setPatEditar, setModalDetalle, isEdit: setIsEdit });

    const columns = useMemo(() => COLUMNS, [controlTabla]);

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Recaudacion masiva', url: `/recaudacionMasiva` },
        { label: 'Administrador PAT', active: true },
    ];

    const onSubmit = async (data: FiltrosPat) => {
        const rutLimpio = data.rut ? data.rut.replace(/\./g, '') : '';

        if (rutLimpio) {
            controlTabla.manejarCambiosFiltros('filters.rut', rutLimpio);
        } else {
            controlTabla.manejarCambiosFiltros('filters.rut', '');
        }

        if (data.llavePat) {
            controlTabla.manejarCambiosFiltros('filters.llavePat', data.llavePat.toString());
        } else {
            controlTabla.manejarCambiosFiltros('filters.llavePat', '');
        }

        await controlTabla.fetchData();
    };
    
    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <CustomAccordion
                                title='Filtros'
                                expandedDefault
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>
                                        <Grid2 size={3}>
                                            <InputRut
                                                name="rut"
                                                control={control}
                                                label="RUT deudor"
                                                error={errors.rut}
                                            />
                                        </Grid2>
                                        <Grid2 size={3}>
                                            <InputText
                                                name="llavePat"
                                                control={control}
                                                label='Llave PAT'
                                            />
                                        </Grid2>
                                        <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_ver]}>
                                        <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                                Filtrar
                                            </MButton>
                                        </Grid2>
                                        </PermissionGuard>
                                    </Grid2>
                                </form>
                            </CustomAccordion>
                            <Tabla
                                columns={columns}
                                control={controlTabla}
                                url={urlTabla}
                                callApi={false}
                                titulo={
                                    <TableHeader
                                        title=""
                                        control={controlTabla}
                                        buttonExport={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel(controlTabla.data, columns, "PAT")}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                    />
                                }
                            />
                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
            <ModalPat
                show={modalDetalle}
                datosEditar={patEditar}
                onHide={() => setModalDetalle(false)}
                refresh={() => controlTabla.fetchData()}
                isEditing={isEdit}
            />
        </>
    );
}

export default AdministradorPat;
